import { createContext, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(null);
  const [countryNumber, setCountryNumber] = useState(null);

  const { i18n } = useTranslation();
  const locale = window.navigator.language;

  const handleWhatIsLanguage = () => {
    switch (locale) {
      case 'pt':
      case 'pt-BR':
        setLanguage('1');
        setCountryNumber('55');

        i18n.changeLanguage('pt');
        break;
      case 'en':
      case 'en-US':
        setLanguage('3');
        setCountryNumber('1');

        i18n.changeLanguage('en');
        break;
      default:
        setLanguage('1');
        setCountryNumber('55');
    }
  }

  useEffect(() => {
    handleWhatIsLanguage();
  }, [language]);

  return (
    <LanguageContext.Provider value={{
      countryNumber,
      language
    }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => {
  return useContext(LanguageContext);
}